// HubSpot Analytics - Main Entry Point
// Single entry point for all HubSpot tracking functionality

import { trackPageView, identifyUser, trackEvent, onRouteChange } from './tracking';

// Named exports for individual functions
export { trackPageView, identifyUser, trackEvent, onRouteChange };

// Export types
export type {
  HubSpotUserIdentity,
  HubSpotPageViewOptions,
  HubSpotCommand,
  HubSpotCustomBehavioralEvent,
} from './types';

// Default export with commonly used functions (for convenience)
export default {
  trackPageView,
  identifyUser,
  trackEvent,
  onRouteChange,
};
